<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="table-ctn verpurcls" style="margin-top: 5px">
            <el-table :header-cell-class-name="cellClass" @selection-change="onRowSelect" :header-cell-style="{ background: '#F2F6FC' }" :data="OrderDatas" border
                style="width: 100%; margin-bottom: 0px">
                <el-table-column fixed type="selection" width="55" reserve-selection :selectable="selectInit"></el-table-column>
                <el-table-column prop="CusName" label="供应商" show-overflow-tooltip></el-table-column>
                <el-table-column width="180px" prop="OrderCode" label="订单号" show-overflow-tooltip></el-table-column>、
                <el-table-column width="160px" prop="CreateTime" label="下单时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer" style="margin-top: 5px">
            <el-button size="small" class="btn-primary" @click="submitForm">提交</el-button>
            <el-button size="small" type="primary" @click="saveMuilPurOrders()">全部新建</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['OrderDatas', 'GoodsData', 'WHId'],
    components: {},
    data() {
        return {
            loading: false,
            selection: [],
            cusId: '',
            permission: {},
        };
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('multiSupplierPurchase');
        if (!that.OrderDatas || !that.GoodsData) {
            that.$util.warningMsg('未检测到可合并数据');
        }
    },
    methods: {
        cellClass(row) {
            if (row.columnIndex === 0) {
                return 'disabledCheck';
            }
        },
        saveMuilPurOrders() {
            let that = this;
            that.loading = true;
            let HadSaveTempPer = that.permission.saveTemp != null && that.permission.saveTemp != "";
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/AddMultiSuPurOrders',
                    data: { IsCreate: true, HadSaveTempPer: HadSaveTempPer, WHId: this.WHId, GoodsList: this.GoodsData }
                })
                .then(() => {
                    that.$util.successMsg('保存采购订单成功');
                    that.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        submitForm() {
            let that = this;
            if (!that.selection || that.selection.length == 0) {
                that.$util.warningMsg('未选中要合并的数据');
            }
            let mergeData = [];
            for (let i = 0; i < that.selection.length; i++) {
                let m = {
                    CusId: that.selection[i].CusId,
                    OrderId: that.selection[i].OrderId
                };
                mergeData.push(m);
            }
            that.loading = true;
            let HadSaveTempPer = that.permission.saveTemp != null && that.permission.saveTemp != "";
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/AddMulPurOrders_V2',
                    data: { GoodsList: this.GoodsData, MergeModels: mergeData, WHId: this.WHId, HadSaveTempPer: HadSaveTempPer }
                })
                .then(() => {
                    that.$util.successMsg('保存采购订单成功');
                    that.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        onRowSelect(val) {
            this.selection = val;
        },
        selectInit(row, index) {
            let that = this;
            if (that.selection.length > 0) {
                let i = that.selection.findIndex(item => {
                    if (item.CusId == row.CusId && item.OrderId != row.OrderId) {
                        return true;
                    }
                });
                if (i > -1) {
                    return false;
                } else return true;
            } else {
                return true;
            }
        }
    }
};
</script>

<style lang="less">
.verpurcls {
    .el-table .disabledCheck .cell .el-checkbox__inner {
        display: none !important;
    }

    .el-table .disabledCheck .cell::before {
        content: '选择';
        text-align: center;
    }
}
</style>